import * as React from "react";
const SvgPlus = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M6 1V11M11 6H1", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgPlus;
